import { action, computed, observable, makeObservable } from 'mobx';
import {successAlert, openFileStack} from 'shared/tools';
import Candidate from 'main/stores/recruiting/Candidate';
import CandidateViewModel from 'main/containers/recruiting/state/CandidateViewModel';
import {t} from 'shared/core';
import Answer from 'main/stores/recruiting/Answer';
import recruitingStore from 'main/stores/recruiting/RecruitingStore';

class CandidateFormState {
  store = recruitingStore;
  history;
  match;
  enforceRequiredFields;

  candidateViewModel = new CandidateViewModel(new Candidate());
  errors = {};
  submitted = false;
  position;
  isUploading = false;

  constructor() {
    makeObservable(this, {
      candidateViewModel: observable,
      errors: observable,
      submitted: observable,
      position: observable,
      isUploading: observable,
      load: action,
      onUploadStarted: action,
      onUploadFinished: action,
      calculateQuestionRequired: action,
      createCandidate: action,
      submitApplication: action,
      candidate: computed,
      editingCandidate: computed
    });
  }

  receiveProps({history, match, enforceRequiredFields = true}) {
    this.history = history;
    this.match = match;
    this.enforceRequiredFields = enforceRequiredFields;
  }

  async load() {
    this.position = await this.store.loadSingle(this.match.params.id);

    for (const question of this.position.questions) {
      this.candidate.answers.push(new Answer({question: question}));
    }
  }

  onUploadStarted() {
    this.isUploading = true;
  }

  onUploadFinished() {
    this.isUploading = false;
  }

  calculateQuestionRequired(question) {
    return this.enforceRequiredFields && question.required;
  }

  async createCandidate() {
    const {errors, model} = await this.store.postCandidate(this.candidate, this.match.params.id);
    if (model) {
      this.history.goBack();
      successAlert(t('recruiting.alerts.Candidate successfully added'));
    }
    this.errors = errors;
  }

  async submitApplication() {
    const origin = new URLSearchParams(this.history.location.search).get('origin');
    if (origin) {
      this.candidate.merge({origin});
    }
    const {errors, model} = await this.store.postApplication(this.candidate, this.match.params.slug, this.match.params.id);
    if (model) {
      this.submitted = true;
    }
    this.errors = errors;
  }

  get candidate() {
    return this.candidateViewModel.candidate;
  }

  get editingCandidate() {
    return this.candidateViewModel.candidate;
  }

  uploadFileForAnswer(answer) {
    openFileStack({
      storeTo: { path: 'resumes/' }
    }, file => answer.merge({attachment: file}));
  }
}

export default CandidateFormState;
